import SectionProfileDetail from "./SectionProfileDetail";

export default SectionProfileDetail